import React from "react"
import { ArrowRight, Clock } from "lucide-react"
import { useLang } from "./i18n/LangContext"
import { useWaitlistModal } from "./WaitlistModalContext"
import { PlaceholderImage } from "./PlaceholderImage"

export function HeroSection() {
  const { t } = useLang()
  const { openModal } = useWaitlistModal()

  return (
    <section className="relative overflow-hidden bg-white dark:bg-gray-950 py-24 sm:py-36">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_-10%,rgba(126,86,163,0.15),transparent)] dark:bg-[radial-gradient(ellipse_80%_60%_at_50%_-10%,rgba(126,86,163,0.22),transparent)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_80%_80%,rgba(245,158,11,0.07),transparent)] dark:bg-[radial-gradient(ellipse_60%_40%_at_80%_80%,rgba(245,158,11,0.10),transparent)]" />
      </div>

      <div className="mx-auto max-w-3xl px-4 sm:px-6 text-center">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-50 dark:bg-brand-950 px-3 py-1 text-xs font-medium text-brand-700 dark:text-brand-300 ring-1 ring-brand-200 dark:ring-brand-800 mb-8">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-500" />
          </span>
          {t.hero.badge}
        </span>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 dark:text-white text-balance leading-tight">
          {t.hero.headline1}{" "}
          <span className="bg-gradient-to-r from-brand-600 to-brand-400 dark:from-brand-400 dark:to-brand-200 bg-clip-text text-transparent">
            {t.hero.headline2}
          </span>
        </h1>

        <p className="mt-6 text-lg sm:text-xl text-gray-500 dark:text-gray-400 text-pretty max-w-2xl mx-auto">
          {t.hero.subheadline}
        </p>

        <div className="mt-10 flex flex-col items-center gap-3">
          <button
            type="button"
            onClick={() => openModal("hero")}
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-600 px-6 py-3.5 text-sm sm:text-base font-semibold text-white hover:bg-brand-700 dark:bg-brand-500 dark:hover:bg-brand-600 active:scale-95 transition-all"
          >
            {t.hero.cta} <ArrowRight className="h-4 w-4" />
          </button>
          <p className="flex items-center gap-1.5 text-xs text-gray-400 dark:text-gray-500">
            <Clock className="h-3 w-3" />
            {t.hero.hint}
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-4 sm:px-6 mt-16">
        <PlaceholderImage
          variant="dashboard"
          aspect="aspect-video"
          label={t.hero.imageLabel}
          className="shadow-2xl shadow-brand-100 dark:shadow-none"
        />
      </div>
    </section>
  )
}
